import type { TeamFilterKey } from '@/lib/api/types/itemFilters';

export const TEAM_PICKLIST_FILTERS = [
  'roleId',
  'skillId',
  'locationId',
] as const satisfies readonly TeamFilterKey[];

export const TEAM_BOOLEAN_FILTERS = [
  'showDeactivatedMembers',
  'showPastMemberships',
  'showFutureMemberships',
] as const satisfies readonly TeamFilterKey[];

export const TEAM_FILTER_KEYS = [
  ...TEAM_PICKLIST_FILTERS,
  ...TEAM_BOOLEAN_FILTERS,
] as const satisfies readonly TeamFilterKey[];

export const getTeamTableFilters = () => [...TEAM_FILTER_KEYS] as const;
